import { render } from "./achieveInfo.vue?vue&type=template&id=3df523fc&scoped=true"
import script from "./achieveInfo.vue?vue&type=script&lang=js"
export * from "./achieveInfo.vue?vue&type=script&lang=js"

import "./achieveInfo.vue?vue&type=style&index=0&id=3df523fc&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df523fc"]])

export default __exports__